import React from "react";
import { KeyRound } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { SignedInRow } from "./security/SecurityBits";
import { ChangePasswordForm } from "./security/ChangePasswordForm";

/** Settings → "Account & security": change the signed-in admin's password. */
export default function SecuritySettings() {
  const { user, refresh } = useAuth();
  return (
    <div data-testid="security-settings" className="border border-zinc-800 rounded-sm">
      <div className="px-5 py-3 border-b border-zinc-800 label-tiny flex items-center gap-2">
        <KeyRound size={12} className="text-amber-500" /> Account &amp; security
      </div>
      <div className="divide-y divide-zinc-800">
        <SignedInRow user={user} />
        <ChangePasswordForm refresh={refresh} />
      </div>
    </div>
  );
}
